export default {
    setCustomerUserId: () => { },
    getAppsFlyerUID: () => { },
};
